<template>
  <b-tabs
    vertical
    nav-wrapper-class="nav-vertical"
  >
    <b-tab title-item-class="training-tab" active>
      <template #title>
        <feather-icon class="align-middle" icon="ClipboardIcon" />
        <span class="align-middle pl-2 pr-3">Dane szkolenia</span>
      </template>
      <vx-card>
        <training-details />
      </vx-card>
    </b-tab>
    <b-tab title-item-class="training-tab" lazy>
      <template #title>
          <feather-icon class="align-middle" icon="ListIcon" />
          <span class="align-middle pl-2 pr-3">Elementy szkolenia</span>
      </template>
      <vx-card>
        <training-elements />
      </vx-card>
    </b-tab>
    <b-tab title-item-class="training-tab" lazy>
      <template #title>
        <feather-icon class="align-middle" icon="FileIcon" />
        <span class="align-middle pl-2 pr-3">Pliki</span>
      </template>
      <vx-card>
        <training-files />
      </vx-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import TrainingDetails from "@/views/administration/trainings/TrainingDetails"
import TrainingElements from "@/views/administration/trainings/TrainingElements"
import TrainingFiles from "@/views/administration/trainings/TrainingFiles"

export default {
  name: 'TrainingsSingle',
  components: {
    TrainingDetails,
    TrainingElements,
    TrainingFiles,
  },
}
</script>
<style lang="scss">
.nav-tabs {
  border: none;
.training-tab .nav-link{
  position: relative;
  background: none !important;
  border: none;
&:not(.active) {
   color: $grey;
&:after {
   content: '';
   width: 0;
   height: 100%;
   border: 1px solid $grey;
   position: absolute;
   top: 0;
   right: 0;
 }
}
&.active {
   color: $secondary;
&:after {
   content: '';
   width: 0;
   height: 100%;
   border: 1px solid $secondary;
   position: absolute;
   box-shadow: 0px 0px 2px $secondary;
   top: 0;
   right: 0;
 }
}
}
}
</style>
